export const Integrations = () => {
    return (
        <section id="integrations">
            <h2>Connect your favorite tools with ours</h2>
            <hr />
        </section>
    );
};
